module.exports = __webpack_public_path__ + "static/media/mark-header.16d08612.png";